exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins);", ""]);

// Module
exports.push([module.id, ":root {\n  --status-color-complete: #ffffff;\n  --status-color-aborted: #d1d0ce;\n  --status-color-queued: #ffc;\n  --status-color-error: #ffd5d5;\n  --status-color-executing: #efe;\n  --status-color-default: #f5f5f5;\n}\n.ProductListTable-module__no_results__1OySF {\n  padding: 40px 0;\n  font-weight: bold;\n}\n.ProductListTable-module__lowerPiceinfo__R-7NN {\n  content: \"\\A\";\n  white-space: pre;\n  -webkit-box-decoration-break: clone;\n          box-decoration-break: clone;\n}\n", ""]);

// Exports
exports.locals = {
	"no_results": "ProductListTable-module__no_results__1OySF",
	"lowerPiceinfo": "ProductListTable-module__lowerPiceinfo__R-7NN"
};